import { useState, useRef, useEffect } from 'react';
import Draggable from 'react-draggable';
import Card from '@atoms/Card';
import Image from '@atoms/Image';
import SvgIconBox from '@atoms/SvgIconBox';
import TimerTime from './TimerTime';
import TimerPlayBtn from '../../public/images/InteractionPage/dynamic-svg/TimerPlayBtn.svg';
import TimerPauseBtn from '../../public/images/InteractionPage/dynamic-svg/TimerPauseBtn.svg';
import TimerResetBtn from '../../public/images/InteractionPage/dynamic-svg/TimerResetBtn.svg';

const TimerOverlay = ({ onClose }) => {
  const STATUS = {
    RESUME: 'resume',
    START: 'start',
    STOP: 'stop',
    RESET: 'reset',
    DONE: 'done'
  };

  const [timerStatus, setTimerStatus] = useState(STATUS.START);
  const [arrowCount, setArrowCount] = useState(0);

  const [minutes, _setMinutes] = useState('05');
  const [seconds, _setSeconds] = useState('00');
  const minutesRef = useRef(minutes);
  const secondsRef = useRef(seconds);

  const [time, setTime] = useState(Number(minutes) * 60 * 1000 + Number(seconds) * 1000);

  const setMinutes = (data) => {
    minutesRef.current = data;
    _setMinutes(data);
  };

  const setSeconds = (data) => {
    secondsRef.current = data;
    _setSeconds(data);
  };

  const timerStyle = (count) => {
    const cardZeroStyle = {
      width: '53.5',
      height: '33.5',
      firstImageWidth: '16',
      firstImageHeight: '16',
      secondImageWidth: '16',
      secondImageHeight: '16',
      thirdImageHeight: '16',
      thirdImageWidth: '16',
      firstImageRight: '',
      secondImageRight: '7',
      thirdImageRight: '2',
      marginTopImage: '1',
      paragraphMarginBottom: '4',
      paragraphPaddingTop: '4',
      paragraphTextSize: '4xl',
      minTextSize: 'xs',
      paraPaddingY: '2',
      inputWidth: '10',
      inputHeight: '6',
      paraTop: '1.5',
      buttonText: 'xs',
      buttonPx: '3',
      buttonPy: '1',
      timerWidth: '36',
      fontSize: 'text-2xl',
      inputBoxWidth: '9',
      inputBoxHeight: '9',
      textWidth: 'w-8 h-9',
      textSize: 'text-2xl',
      textTop: '5',
      timerCard: 'p-3'
    };

    const cardOneStyle = {
      width: '57',
      height: '36',
      firstImageWidth: '20',
      firstImageHeight: '20',
      secondImageWidth: '20',
      secondImageHeight: '20',
      thirdImageHeight: '20',
      thirdImageWidth: '20',
      firstImageRight: '12',
      secondImageRight: '7',
      thirdImageRight: '2',
      marginTopImage: '1',
      paragraphMarginBottom: '6',
      paragraphPaddingTop: '8',
      paragraphTextSize: '6xl',
      minTextSize: 'sm',
      paraPaddingY: '3',
      inputWidth: '12',
      inputHeight: '7',
      paraTop: '1',
      buttonText: 'sm',
      buttonPx: '3',
      buttonPy: '1',
      timerWidth: '42.5',
      fontSize: 'text-4xl -mt-2',
      inputBoxWidth: '14',
      inputBoxHeight: '14',
      textWidth: 'w-12 h-12',
      textSize: 'text-4xl',
      textTop: '8',
      timerCard: 'py-3'
    };

    const cardTwoStyle = {
      width: '79',
      height: '60',
      firstImageWidth: '29',
      firstImageHeight: '29',
      secondImageWidth: '29',
      secondImageHeight: '29',
      thirdImageHeight: '31',
      thirdImageWidth: '31',
      firstImageRight: '10',
      secondImageRight: '',
      thirdImageRight: '2',
      marginTopImage: '1',
      paragraphMarginBottom: '16',
      paragraphPaddingTop: '16',
      paragraphTextSize: '8xl',
      minTextSize: 'lg',
      paraPaddingY: '6',
      inputWidth: '16',
      inputHeight: '10',
      paraTop: '1',
      buttonText: 'sm',
      buttonPx: '6',
      buttonPy: '3',
      timerWidth: '58.25',
      fontSize: 'text-5xl',
      inputBoxWidth: '16',
      inputBoxHeight: '20',
      textWidth: 'w-16 h-16',
      textSize: 'text-5xl',
      textTop: '10',
      timerCard: 'pt-4 pb-4'
    };

    if (count === 0) {
      return cardZeroStyle;
    }
    if (count === 1) {
      return cardOneStyle;
    }
    return cardTwoStyle;
  };

  const qqProps = { className: 'fill-current text-neutral-50 group-hover:text-white', width: 12 };
  const svgBoxClass = 'w-10 h-10 dark:bg-neutral-80';

  const getZero = (digit) => {
    if (String(digit).length > 1) {
      return digit;
    }
    return String(digit).padStart(2, '0');
  };

  const getFormatedTime = (milliseconds) => {
    const totalSeconds = parseInt(Math.floor(milliseconds / 1000), 10);
    const totalMinutes = parseInt(Math.floor(totalSeconds / 60), 10);

    const s = parseInt(totalSeconds % 60, 10);
    const m = parseInt(totalMinutes % 60, 10);
    setMinutes(getZero(m));
    setSeconds(getZero(s));
    setTime(milliseconds);
    return { minutes: m, seconds: s };
  };

  const setFormatedTime = () => {
    setTimeout(() => {
      if (time > 0) {
        setTime(time - 1000);
        getFormatedTime(time - 1000);
      }
      if (time === 0) { setTimerStatus('reset'); }
    }, 1000);
  };

  const resetTimer = () => {
    setMinutes('05');
    setSeconds('00');
    setTime(5 * 60 * 1000 + 0 * 1000);
  };

  useEffect(() => {
    if (timerStatus === STATUS.STOP) {
      setFormatedTime();
    }
  }, [time, timerStatus, minutes, seconds]);

  const saveTime = (min, sec) => {
    setTime(Number(min) * 60 * 1000 + Number(sec) * 1000);
  };

  return (
    <Draggable bounds={{
      bottom: 3, right: 3
    }} >
      <div>
        <Card style={{ backgroundColor: 'rgba(34, 34, 34, 0.9)' }} className={`shadow-0.75 w-${timerStyle(arrowCount).width}  flex flex-col opacity-100`} children={
          <>
            <div className='bg-toggleGray'>
              {arrowCount !== 0 && <Image onClick={() => { if (arrowCount <= 2 && arrowCount >= 0) setArrowCount(arrowCount - 1); }} src="/images/contract.svg" width={timerStyle(arrowCount).firstImageWidth} height={timerStyle(arrowCount).firstImageHeight} alt={'contract-icon'} className={`absolute rounded-none inline mt-${timerStyle(arrowCount).marginTopImage} right-${timerStyle(arrowCount).firstImageRight} mr-0 cursor-pointer`} />}
              {arrowCount !== 2 && <Image onClick={() => { if (arrowCount <= 2 && arrowCount >= 0) setArrowCount(arrowCount + 1); }} src="/images/contract1.svg" width={timerStyle(arrowCount).secondImageWidth} height={timerStyle(arrowCount).secondImageHeight} alt={'contract-icon'} className={`absolute rounded-none inline mt-${timerStyle(arrowCount).marginTopImage} right-${timerStyle(arrowCount).secondImageRight} mr-0 cursor-pointer`} />}
              <Image onClick={onClose} src="/images/cross.svg" width={timerStyle(arrowCount).thirdImageWidth} height={timerStyle(arrowCount).thirdImageHeight} alt={'contract-icon'} className={`absolute rounded-none inline mt-${timerStyle(arrowCount).marginTopImage} right-${timerStyle(arrowCount).thirdImageRight} mr-0 cursor-pointer`} />
            </div>

            <div className={`pt-${timerStyle(arrowCount).textTop} px-9`}>
              <TimerTime
                arrowCount={arrowCount}
                timerStyle={timerStyle}
                minutes={minutesRef.current}
                setMinutes={setMinutes}
                seconds={secondsRef.current}
                setSeconds={setSeconds}
                saveTime={saveTime}
                getZero={getZero}
              />
            </div>

            <div className=' py-2 flex justify-center gap-2'>
              {
                timerStatus === 'start' && <SvgIconBox id="qqButtonCtdId"
                  onClick={() => { setTimerStatus('stop'); }}
                  svg={<TimerPlayBtn {...qqProps} />} className={`${svgBoxClass} `}
                />
              }

              {
                timerStatus === 'resume' && <SvgIconBox id="qqButtonCtdId"
                  onClick={() => { setTimerStatus('stop'); }}
                  svg={<TimerPlayBtn {...qqProps} />} className={`${svgBoxClass} `}
                />
              }

              {
                timerStatus === 'stop' && <SvgIconBox id="qqButtonCtdId"
                  onClick={() => { setTimerStatus('resume'); }}
                  svg={<TimerPauseBtn {...qqProps} />} className={`${svgBoxClass} `}
                />
              }

              {
                timerStatus === 'resume' && <SvgIconBox id="qqButtonCtdId"
                  onClick={() => { setTimerStatus('start'); resetTimer(); }}
                  svg={<TimerResetBtn {...{ className: 'fill-current text-neutral-50 group-hover:text-white', width: 18 }} />} className={`${svgBoxClass} `}
                />
              }
            </div>
          </>
        } />
      </div>
    </Draggable>
  );
};

export default TimerOverlay;
